import { AppEvent } from '../constants/events';
import { getHomeCollection } from '../helpers/collectionHelper';
import { getCollectionBounds, getFocusAction } from '../helpers/mapToolsHelper';
import { getTrailSegments4Map } from '../helpers/elevationChartHelper';
import { uiConstants } from '../constants/constants';

const initialState = {
    mapLoaded: false,
    collection: {
        activeGuid: null,
        home: {},
        trail: {},
        group: {},
    },
    mapActionStack: [],
    uiStates: {
        trailListLayout: uiConstants.trailListLayout.grid,
        trailListSortRule: null,
    },
    modal: {
        opened: false,
    },
};

export default function presentationState(state = initialState, action) {
    switch (action.type) {
        case AppEvent.client.SET_COLLECTION_SORT_RULE: {
            const newState = { ...state };
            newState.uiStates.trailListSortRule = action.newRule;
            return newState;
        }
        case AppEvent.client.SET_TRAIL_LIST_LAYOUT: {
            const newState = { ...state };
            newState.uiStates.trailListLayout = action.newLayout;
            return newState;
        }
        case AppEvent.client.FOCUS_MAP_FEATURE: {
            const newState = { ...state };
            newState.mapActionStack.push(getFocusAction(action.feature));
            return newState;
        }
        // MAP PREVIEW
        case AppEvent.client.PREVIEW_ACTIVE_HOME_COLLECTION: {
            const newState = { ...state };
            newState.collection.activeGuid = null;
            const collection = {
                ...newState.collection.home,
            };
            newState.mapActionStack.push({
                collection,
                bounds: getCollectionBounds(collection),
            });
            return newState;
        }
        case AppEvent.client.PREVIEW_ACTIVE_TRAILS_GROUP_COLLECTION: {
            const newState = { ...state };
            const { uuid } = action;
            newState.collection.activeGuid = uuid;
            const collection = {
                ...newState.collection.group[uuid],
            };
            newState.mapActionStack.push({
                collection,
                bounds: getCollectionBounds(collection),
            });
            return newState;
        }
        case AppEvent.client.PREVIEW_ACTIVE_TRAIL_COLLECTION: {
            const newState = { ...state };
            const { uuid } = action;
            newState.collection.activeGuid = uuid;
            const collection = {
                ...newState.collection.trail[uuid],
            };
            newState.mapActionStack.push({
                collection: getTrailSegments4Map(collection),
                bounds: getCollectionBounds(collection),
            });
            return newState;
        }
        // COLLECTION LOAD
        case AppEvent.client.HOME_GEOJSON_LOADED: {
            const newState = { ...state };
            const { trails } = action;
            const collection = getHomeCollection(trails);
            newState.collection.activeGuid = null;
            newState.collection.home = collection;
            newState.mapActionStack.push({
                collection,
                bounds: getCollectionBounds(collection),
            });
            return newState;
        }
        case AppEvent.client.GROUP_GEOJSON_LOADED: {
            const newState = { ...state };
            const { trails, uuid } = action;
            const collection = getHomeCollection(trails, uuid);
            newState.collection.activeGuid = uuid;
            newState.collection.group[uuid] = {
                ...collection,
            };
            newState.mapActionStack.push({
                collection,
                bounds: getCollectionBounds(collection),
            });
            return newState;
        }
        case AppEvent.client.TRAIL_GEOJSON_LOADED: {
            const newState = { ...state };
            const { collection, uuid } = action.payload;
            newState.collection.activeGuid = uuid;
            newState.collection.trail[uuid] = {
                ...collection,
            };
            // newState.collection.home = {};
            newState.mapActionStack.push({
                collection,
                bounds: getCollectionBounds(collection),
            });
            return newState;
        }
        case AppEvent.client.SET_MODAL_STATE: {
            const newState = { ...state };
            newState.modal = { ...action.payload };
            return newState;
        }
        case AppEvent.map.MAP_LOADED: {
            const newState = { ...state };
            newState.mapLoaded = true;
            return newState;
        }
        default:
            return state;
    }
}
